import React from 'react';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {isMobile} from 'react-device-detect';


function MiddlewareAbility({tableKey, side, cell}) {

    const {showMiddleware} = useTypedSelector(state => state.animation);

    let rootClasses = 'taeContainer';
    let taeClasses = '';
    if(showMiddleware.tableKey !== null && showMiddleware.tableKey === tableKey && showMiddleware.side === side ){
        rootClasses += ' taeContainerActive';
        taeClasses += 'tae ';
    }

    if(isMobile){
        taeClasses += ' animateTaeCustomMobile';
    }else{
        taeClasses += ' animateTaeCustom';
    }

    let tae = '';
    let abName = '';
    if(cell !== 0 && cell !== null && cell.card.ability !== null){
        tae = cell.card.ability.tae;
        abName = cell.card.ability.ab_name;
    }

    return (
        <div className={rootClasses}  >
            <div className={taeClasses + ' ' + tae + ' font-oswald-bold'} > {abName} </div>
        </div>
    );
}

export default MiddlewareAbility;